export * from './citpermit.service';
export * from '../citizen/profile.service';
export * from '../core/index.service';
export * from '../services/index.service';


// WEBPACK FOOTER //
// D:/NewPhoenixScrum/PhoenixScrum/Main/CitizenSevicesEx/CSClient/CSClient/client/app/citpermit/index.service.ts